import { render, staticRenderFns } from "./SimpleSnackbar.vue?vue&type=template&id=6e34143a&scoped=true"
import script from "./SimpleSnackbar.vue?vue&type=script&lang=js"
export * from "./SimpleSnackbar.vue?vue&type=script&lang=js"
import style0 from "./SimpleSnackbar.vue?vue&type=style&index=0&id=6e34143a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../ans-public-translator-ai/node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e34143a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../ans-public-translator-ai/node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
